import { IconButton, Menu, MenuItem } from "@mui/material";
import React from "react";
import SetDefaultPassword from "../../../../components/setDefaultPassword/setDefaultPassword";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import CoachProps from "../interface/coachProps";
import { CoachListContext } from "../context/coachListContext";
import EditCoachProps from "../interface/editCoachProps";

const OptionMenu = ({ coach }: { coach: CoachProps }): React.JSX.Element => {
  const {
    setEditCoach,
  }: {
    setEditCoach: (editCoach: EditCoachProps) => void;
  } = React.useContext(CoachListContext);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void =>
    setAnchorEl(event.currentTarget);

  const handleClose = (): void => setAnchorEl(null);

  return (
    <React.Fragment>
      <IconButton
        sx={{ mr: 1 }}
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {
          <MoreHorizOutlinedIcon
            sx={{
              transform: "rotate(90deg)",
            }}
          />
        }
      </IconButton>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <SetDefaultPassword
          userId={coach.user_id}
          disabled={coach.active === 0}
        />

        <MenuItem
          disabled={coach.active === 0}
          onClick={() => setEditCoach({ showDialog: true, coach: coach })}
        >
          Daten bearbeiten
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
};

export default OptionMenu;
